var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('span',[_vm._v(_vm._s(_vm.sum1))]),_c('span',{staticStyle:{"font-size":"12px"}},[_vm._v(_vm._s(_vm.sum2))])])
}
var staticRenderFns = []

export { render, staticRenderFns }